module.exports = __webpack_public_path__ + "static/step2-6aed7fb344a29462f3de470f01eb3ac4.png";